import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  items: [],
  total_count: null,
  current_page: null,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: ''
}

const notifications = createReducer(initialState, {
  'ntf/CLEAR_NOTIFICATIONS': (state, action) => ({
    ...state,
    items: []
  }),
  'ntf/GET_NOTIFICATIONS': (state, action) => ({
    ...state,
    isFetching: true
  }),
  'ntf/GET_NOTIFICATIONS_SUCCESSFUL': (state, action) => {
    return {
      ...state,
      items: [...state.items, ...action.payload.response.data],
      isFetching: false,
      total_count: action.payload.response.meta.total_count,
      current_page: action.payload.current_page
    }
  }
})

export default notifications
